const BACKEND_URLS = {
    TEST: "https://test.backendbiz.travelandz.com",
    PROD: "https://backend.business.travelandz.com",
};

const FRONTEND_URLS = {
    TEST: "https://test.biz.travelandz.com",
    PROD: "https://business.travelandz.com",
};

const getCurrentUrl = () => {
    const origin = window.location.origin;

    if (
        [
            "https://travelandz4b.com",
            "https://travelandz.com",
            "https://www.travelandz.com",
        ].includes(origin)
    ) {
        return {
            backend: BACKEND_URLS.PROD,
            frontend: FRONTEND_URLS.PROD,
        };
    }

    return {
        backend: BACKEND_URLS.TEST,
        frontend: FRONTEND_URLS.TEST,
    };
};

export {
    getCurrentUrl,
    BACKEND_URLS as BUSINESS_BACKEND_URLS,
    FRONTEND_URLS as BUSINESS_FRONTEND_URLS,
};
